/**
 * @genesis_domain Theme Engine
 * @genesis_version V9.1
 * @genesis_intent Defines the ThemeSchema Zod contract and inferred Theme type for system-curated UI theme definitions.
 *   Themes are identity-only database rows that map to [data-theme="slug"] CSS selectors.
 *   Actual CSS token values reside exclusively in frontend/src/styles/tokens.css (Single Source of Truth).
 * @genesis_boundaries FORBIDDEN from containing mutation logic or database queries. Pure validation only.
 *   FORBIDDEN from defining CSS variable maps — tokens.css is the exclusive SSOT.
 * @genesis_ai_trail V11.0 Eradication: Removed variables column (Split-Brain Configuration).
 *   useThemeInjector now switches data-theme attributes instead of imperative setProperty() injection.
 *   Legitimate 0 and false values preserved via Nullish Coalescing (??) only.
 */

import { z } from 'zod';

import { BaseModelSchema } from './common.js';

export const ThemeSchema = BaseModelSchema.extend({
    name: z.string().min(1, 'Theme name is required'),
    isSystem: z.boolean(),
});

export type Theme = z.infer<typeof ThemeSchema>;
